var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { loadScript } from '../../../base/base';
import { qqShareData } from './utils/api';
class QQShare extends React.PureComponent {
    componentDidMount() {
        const { content } = this.props;
        const shareConfig = content || {};
        const window = {};
        if (typeof window.WeixinJSBridge == 'undefined') {
            document.addEventListener('WeixinJSBridgeReady', () => {
                this.WXSHARE(shareConfig);
            });
        }
        else {
            this.WXSHARE(shareConfig);
        }
        if (!content || !content.title) {
            console.log('未传入分享参数,传入格式为{title:xxx,img:xxx,desc:xxx}');
        }
    }
    WXSHARE(params) {
        return __awaiter(this, void 0, void 0, function* () {
            yield loadScript('https://res.wx.qq.com/open/js/jweixin-1.0.0.js', { cache: false });
            const ua = navigator.userAgent;
            let appType = '凤凰新闻';
            if (params.appType && params.appType === 'videoApp') {
                appType = '凤凰视频';
            }
            const shareImg = params.img || 'https://p1.ifengimg.com/29b92e35b2b20708/2017/51/ifengLogo300x300.jpg';
            const shareTitle = params.title || appType;
            const shareContent = (params.desc && `${params.desc} - ${appType}`) || `-来自${appType}客户端`;
            const shareTimeline = (params.title && `${params.title} - ${appType}`) || `-来自${appType}客户端`;
            // 避免拉起时候url改变，需要传入固定spa url
            const shareLink = params.url || window.location.href;
            // document.title = params.title;
            if (/MicroMessenger/i.test(ua) || /QQ/i.test(ua)) {
                const wxConfig = {};
                const windows = window || {};
                let wxShareDataObj = null;
                let startTime = new Date().getTime();
                try {
                    wxShareDataObj = yield qqShareData();
                }
                catch (error) {
                    if (typeof window == 'object' && window.BJ_REPORT)
                        window.BJ_REPORT.report(error, false, 'wx_share_ajax');
                }
                let endTime = new Date().getTime();
                if (wxShareDataObj && wxShareDataObj.data) {
                    wxConfig.debug = false;
                    wxConfig.appId = wxShareDataObj.data.appId;
                    wxConfig.timestamp = wxShareDataObj.data.timestamp;
                    wxConfig.nonceStr = wxShareDataObj.data.nonceStr;
                    wxConfig.signature = wxShareDataObj.data.signature;
                    wxConfig.jsApiList = [
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareQZone',
                        'onMenuShareTimeline',
                        'onMenuShareWeibo',
                    ];
                    if (windows.wx) {
                        if (windows.wx.config) {
                            windows.wx.config(wxConfig);
                        }
                        windows.wx.ready(() => {
                            if (windows.wx) {
                                windows.wx.onMenuShareAppMessage({
                                    title: shareTitle,
                                    imgUrl: shareImg,
                                    link: shareLink,
                                    desc: shareContent,
                                    success: () => {
                                        if (params.cb) {
                                            params.cb();
                                        }
                                    },
                                    fail: (error = {}) => {
                                        if (typeof window == 'object' && window.BJ_REPORT)
                                            window.BJ_REPORT.report(error, false, 'wx_share_err');
                                    },
                                });
                                windows.wx.onMenuShareTimeline({
                                    title: shareTimeline,
                                    link: shareLink,
                                    imgUrl: shareImg,
                                    success: () => {
                                        if (params.cb) {
                                            params.cb();
                                        }
                                    },
                                    fail: (error = {}) => {
                                        if (typeof window == 'object' && window.BJ_REPORT)
                                            window.BJ_REPORT.report(error, false, 'wx_share_err');
                                    },
                                });
                                windows.wx.onMenuShareQZone({
                                    title: shareTitle,
                                    desc: shareContent,
                                    link: shareLink,
                                    imgUrl: shareImg,
                                    success: () => {
                                        if (params.cb) {
                                            params.cb();
                                        }
                                    },
                                    fail: (error = {}) => {
                                        if (typeof window == 'object' && window.BJ_REPORT)
                                            window.BJ_REPORT.report(error, false, 'wx_share_err');
                                    },
                                });
                                windows.wx.onMenuShareQQ({
                                    title: shareTitle,
                                    desc: shareContent,
                                    link: shareLink,
                                    imgUrl: shareImg,
                                    success: () => {
                                        if (params.cb) {
                                            params.cb();
                                        }
                                    },
                                    fail: (error = {}) => {
                                        if (typeof window == 'object' && window.BJ_REPORT)
                                            window.BJ_REPORT.report(error, false, 'wx_share_err');
                                    },
                                });
                            }
                        });
                        if (windows.wx.error) {
                            windows.wx.error((res) => {
                                if (typeof window == 'object' && window.BJ_REPORT)
                                    window.BJ_REPORT.report(res, false, 'wx_share_err');
                                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                            });
                        }
                    }
                }
            }
        });
    }
    render() {
        return null;
    }
}
export default QQShare;
